module.exports = __webpack_public_path__ + "img/bank-center.05f367da.png";